import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { isEmpty as _isEmpty } from 'lodash';
import utils from '@gisatcz/ptr-utils';
import ActionTypes from '../../constants/ActionTypes';
import common from '../_common/reducers';
import helpers from './helpers';
export var INITIAL_STATE = {};
/**
 * Update component
 * @param state {Object}
 * @param componentKey {string}
 * @param update {Object}
 * @return {Object} state
 */

function update(state, componentKey, update) {
  if (!_isEmpty(update)) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, componentKey, state[componentKey] ? _objectSpread(_objectSpread({}, state[componentKey]), update) : update));
  } else {
    return state;
  }
}
/**
 * Remove component
 * Remove whole component or if path is defined, remove just everything on path.
 * @param state {Object}
 * @param componentKey {string}
 * @param path {string} Dot separated path or "" or null.
 * @return {Object} state
 */


function remove(state, componentKey) {
  var path = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var pathForComponent = !path || path === null || path === '';

  if (componentKey && (pathForComponent || path)) {
    var pathParams = !pathForComponent && path.split('.');

    if (pathForComponent) {
      return utils.stateManagement.removeItemByKey(state, componentKey);
    } else {
      return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, componentKey, helpers.setHelper(state[componentKey], pathParams, undefined)));
    }
  } else {
    return state;
  }
}
/**
 * Set value in given path
 * @param state {Object}
 * @param componentKey {string}
 * @param path {string} data.property.something
 * @param value {*}
 * @return {Object} state
 */


function set(state, componentKey, path, value) {
  if (componentKey && path) {
    var pathParams = path.split('.');
    var componentState = state[componentKey] || {};
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, componentKey, helpers.setHelper(componentState, pathParams, value)));
  } else {
    return state;
  }
} // helpers ---------------------------------------------------------------------


export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.COMPONENTS.UPDATE:
      return update(state, action.component, action.update);

    case ActionTypes.COMPONENTS.UPDATE_STORE:
      return common.updateStore(state, action);

    case ActionTypes.COMPONENTS.SET:
      return set(state, action.component, action.path, action.value);

    case ActionTypes.COMPONENTS.REMOVE:
      return remove(state, action.component, action.path);

    default:
      return state;
  }
});